module.exports = "/_next/static/images/10_thum-71222814434c1dbd39bd4330b4f41afc.svg";